import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  IoPersonCircleOutline, 
  IoTimeOutline, 
  IoCalendarOutline, 
  IoAlarmOutline, 
  IoSearch, 
  IoCloseCircle, 
  IoAlertCircleOutline 
} from 'react-icons/io5';

// Web Storage wrapper (using localStorage)
const storage = {
  getItem: (key) => {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      //console.error('Error getting item from localStorage:', error);
      return null;
    }
  },
  setItem: (key, value) => {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      //console.error('Error setting item in localStorage:', error);
    }
  }
};

// Styles
const styles = {
  mainContainer: {
    minHeight: '100vh',
    backgroundColor: '#f5f5f5',
    display: 'flex',
    flexDirection: 'column',
  },
  scrollContainer: {
    flex: 1,
    padding: '16px',
    maxWidth: '800px',
    margin: '0 auto',
    width: '100%',
  },
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '40px',
    minHeight: '400px',
  },
  loadingSpinner: {
    width: '40px',
    height: '40px',
    border: '4px solid #f3f3f3',
    borderTop: '4px solid #137a7f',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
  loadingText: {
    marginTop: '16px',
    fontSize: '16px',
    color: '#666',
    textAlign: 'center',
  },
  errorContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px',
  },
  errorIcon: {
    fontSize: '48px',
    color: '#ff6b6b',
  },
  errorText: {
    fontSize: '16px',
    color: '#ff6b6b',
    textAlign: 'center',
    marginTop: '16px',
    fontWeight: '500',
    marginBottom: '20px',
  },
  retryButton: {
    backgroundColor: '#137a7f',
    paddingHorizontal: '20px',
    paddingVertical: '12px',
    borderRadius: '8px',
    cursor: 'pointer',
    border: 'none',
    color: '#fff',
    fontWeight: '500',
    fontSize: '14px',
  },
  searchContainer: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#fff',
    borderRadius: '12px',
    paddingHorizontal: '16px',
    marginBottom: '20px',
    borderWidth: '1px',
    borderColor: '#ddd',
    borderStyle: 'solid',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  searchIcon: {
    marginRight: '12px',
    fontSize: '20px',
    color: '#999',
  },
  input: {
    flex: 1,
    height: '50px',
    fontSize: '16px',
    color: '#333',
    border: 'none',
    outline: 'none',
    backgroundColor: 'transparent',
  },
  clearButton: {
    padding: '4px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'none',
    border: 'none',
  },
  clearIcon: {
    fontSize: '20px',
    color: '#999',
  },
  resultsCount: {
    fontSize: '14px',
    color: '#666',
    marginBottom: '16px',
    textAlign: 'center',
  },
  card: {
    backgroundColor: '#fff',
    borderRadius: '16px',
    padding: '20px',
    marginBottom: '16px',
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    borderWidth: '1px',
    borderColor: '#e0e0e0',
    borderStyle: 'solid',
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: '20px',
    paddingBottom: '16px',
    borderBottomWidth: '1px',
    borderBottomColor: '#f0f0f0',
    borderBottomStyle: 'solid',
  },
  headerIcon: {
    fontSize: '32px',
    color: '#137a7f',
  },
  profissionalInfo: {
    marginLeft: '12px',
    flex: 1,
  },
  profissional: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#333',
    marginBottom: '4px',
  },
  especialidade: {
    fontSize: '14px',
    color: '#137a7f',
    fontWeight: '500',
  },
  horariosContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  horariosHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '8px',
  },
  horariosIcon: {
    fontSize: '20px',
    color: '#666',
  },
  horariosTitulo: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#333',
    marginLeft: '8px',
  },
  horarioItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#f8f9fa',
    borderRadius: '8px',
    padding: '12px',
  },
  horarioDiaContainer: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
  },
  horarioDiaIcon: {
    fontSize: '16px',
    color: '#666',
  },
  horarioDia: {
    fontSize: '14px',
    color: '#333',
    fontWeight: '500',
    marginLeft: '8px',
  },
  horarioHoraContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  horarioHoraIcon: {
    fontSize: '16px',
    color: '#137a7f',
  },
  horarioHora: {
    fontSize: '14px',
    color: '#137a7f',
    fontWeight: '600',
    marginLeft: '8px',
  },
  emptyContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px',
  },
  emptyIcon: {
    fontSize: '64px',
    color: '#ccc',
  },
  emptyText: {
    fontSize: '16px',
    color: '#666',
    textAlign: 'center',
    marginTop: '16px',
  },
  navbar: {
    backgroundColor: '#137a7f',
    padding: '16px 20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  navbarTitle: {
    color: 'white',
    fontSize: '18px',
    fontWeight: '600',
    margin: 0,
  },
  backButton: {
    position: 'absolute',
    left: '20px',
    background: 'none',
    border: 'none',
    color: 'white',
    fontSize: '20px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  backButtonText: {
    fontSize: '14px',
  },
};

// Add keyframes animation
const styleSheet = document.createElement('style');
styleSheet.textContent = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
document.head.appendChild(styleSheet);

// NavBar Component
const NavBar = ({ title, showBackButton = false }) => {
  const navigate = useNavigate();

  return (
    <div style={styles.navbar}>
      {showBackButton && (
        <button
          onClick={() => navigate(-1)}
          style={styles.backButton}
        >
          ← <span style={styles.backButtonText}>Voltar</span>
        </button>
      )}
      <h1 style={styles.navbarTitle}>{title}</h1>
    </div>
  );
};

export default function EspecialidadesScreen() {
  const [agendamentos, setAgendamentos] = useState([]);
  const [filtro, setFiltro] = useState('');
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const storedLink = storage.getItem('link');
        const storedChave = storage.getItem('chave');
        const storedGuid = storage.getItem('govbr_guid');
        const unidadeCod = storage.getItem('codUnidade');
        const guidParam = storedGuid ? `&GUID=${storedGuid}` : '';

        if (!storedLink || !storedChave || !unidadeCod) {
          throw new Error('Dados necessários não encontrados');
        }

        const url = `${storedLink}/apidadospaciente.rule?sys=SAU&p1=${storedChave}&p2=especialidades&p11=${unidadeCod}${guidParam}`;
        const response = await fetch(url);
        const data = await response.json();

        if (data.status === 'success' && data.dados.length > 0) {
          const agrupados = agruparPorProfissional(data.dados);
          setAgendamentos(agrupados);
        } else {
          throw new Error('Nenhum horário de atendimento encontrado');
        }
      } catch (error) {
        setErro(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const agruparPorProfissional = (dados) => {
    const agrupados = {};

    dados.forEach(item => {
      const key = item.PROFISSIONAL_ESPECIALIDADE;
      if (!agrupados[key]) {
        agrupados[key] = {
          profissional: key.split('/')[0],
          especialidade: key.split('/')[1],
          horarios: []
        };
      }

      agrupados[key].horarios.push({
        dia: item.DIA_SEMANA,
        inicio: item.ESC_INICIO_ATENDIMENTO,
        fim: item.FIM,
      });
    });

    return Object.values(agrupados);
  };

  const agendamentosFiltrados = agendamentos.filter(item =>
    item.profissional.toLowerCase().includes(filtro.toLowerCase()) ||
    item.especialidade.toLowerCase().includes(filtro.toLowerCase())
  );

  const formatarHora = (hora) => {
    if (!hora) return '';
    return hora.slice(0, 5);
  };

  const ordenarHorarios = (horarios) => {
    const ordemDias = ['SEGUNDA', 'TERÇA', 'QUARTA', 'QUINTA', 'SEXTA', 'SÁBADO', 'DOMINGO'];
    return [...horarios].sort((a, b) => {
      return ordemDias.indexOf(a.dia) - ordemDias.indexOf(b.dia);
    });
  };

  const formatarResultados = (quantidade) => {
    if (quantidade === 0) return 'Nenhum profissional encontrado';
    if (quantidade === 1) return '1 profissional encontrado';
    return `${quantidade} profissionais encontrados`;
  };

  const handleRetry = () => {
    navigate('/unidades');
  };

  return (
    <div style={styles.mainContainer}>
      <NavBar title="Horários de Atendimento" showBackButton={true} />

      <div style={styles.scrollContainer}>
        {loading ? (
          <div style={styles.loadingContainer}>
            <div style={styles.loadingSpinner} />
            <div style={styles.loadingText}>Carregando horários...</div>
          </div>
        ) : erro ? (
          <div style={styles.errorContainer}>
            <IoAlertCircleOutline style={styles.errorIcon} />
            <div style={styles.errorText}>Erro: {erro}</div>
            <button
              style={styles.retryButton}
              onClick={handleRetry}
            >
              Voltar para Unidades
            </button>
          </div>
        ) : (
          <>
            <div style={styles.searchContainer}>
              <IoSearch style={styles.searchIcon} />
              <input
                type="text"
                style={styles.input}
                placeholder="Pesquisar profissional ou especialidade..."
                value={filtro}
                onChange={(e) => setFiltro(e.target.value)}
              />
              {filtro.length > 0 && (
                <button
                  onClick={() => setFiltro('')}
                  style={styles.clearButton}
                >
                  <IoCloseCircle style={styles.clearIcon} />
                </button>
              )}
            </div>

            <div style={styles.resultsCount}>
              {formatarResultados(agendamentosFiltrados.length)}
            </div>

            {agendamentosFiltrados.length > 0 ? (
              agendamentosFiltrados.map((item, index) => (
                <div key={index} style={styles.card}>
                  <div style={styles.cardHeader}>
                    <IoPersonCircleOutline style={styles.headerIcon} />
                    <div style={styles.profissionalInfo}>
                      <div style={styles.profissional}>
                        {item.profissional || 'Profissional não informado'}
                      </div>
                      <div style={styles.especialidade}>
                        {item.especialidade || 'Especialidade não informada'}
                      </div>
                    </div>
                  </div>

                  <div style={styles.horariosContainer}>
                    <div style={styles.horariosHeader}>
                      <IoTimeOutline style={styles.horariosIcon} />
                      <div style={styles.horariosTitulo}>Horários de Atendimento</div>
                    </div>

                    {ordenarHorarios(item.horarios).map((horario, idx) => (
                      <div key={idx} style={styles.horarioItem}>
                        <div style={styles.horarioDiaContainer}>
                          <IoCalendarOutline style={styles.horarioDiaIcon} />
                          <div style={styles.horarioDia}>{horario.dia}</div>
                        </div>
                        <div style={styles.horarioHoraContainer}>
                          <IoAlarmOutline style={styles.horarioHoraIcon} />
                          <div style={styles.horarioHora}>
                            {formatarHora(horario.inicio)} - {formatarHora(horario.fim)}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))
            ) : (
              <div style={styles.emptyContainer}>
                <IoTimeOutline style={styles.emptyIcon} />
                <div style={styles.emptyText}>
                  {filtro ? 'Nenhum profissional encontrado para a pesquisa.' : 'Nenhum horário de atendimento encontrado.'}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}